import { useEffect, useRef } from 'react';

//Queries
import { useTicketsOrderCancel } from 'queries/tickets/useTicketsOrderCancel';
import { useCartStore } from 'services/stores/cart';

/**
 * Hook to read/set order id in checkout.
 * @description OrderId is only set when user starts a "checkout"
 */
export const useTicketActiveOrder = () => {
  const ticketingActiveOrderId = useCartStore(
    (state) => state.ticketingActiveOrderId,
  );
  const setTicketingActiveOrderId = useCartStore(
    (state) => state.actions.setTicketingActiveOrderId,
  );

  return {
    ticketingActiveOrderId,
    setTicketingActiveOrderId,
  };
};

/**
 * If a customer came from hosted page with an active cart, cancel order.
 */
export const useWatchTicketActiveOrder = (opts: {
  toggleLoading: (state: boolean) => void;
}) => {
  const alreadyWatched = useRef(false);

  const { cancelOrderAsync } = useTicketsOrderCancel();

  const { ticketingActiveOrderId, setTicketingActiveOrderId } =
    useTicketActiveOrder();

  /**
   * Watch if temp order is set, so we can cancel the order.
   */
  useEffect(() => {
    if (ticketingActiveOrderId && !alreadyWatched.current) {
      opts.toggleLoading(true);

      //Keep as "background" promise
      cancelOrderAsync(ticketingActiveOrderId)
        .then(() => {})
        .finally(() => {
          opts.toggleLoading(false);

          //Clean order
          setTicketingActiveOrderId(undefined);
        });

      //Force execution once.
      alreadyWatched.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //only run on mount
};
